import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import { Row, Col, Card, Button } from "react-bootstrap";
import { SvgBag, SvgEye, SvgWhatsapp, SvgFacebook, SvgTwitter } from "./Svgs";
import { API_BASE_URL, BASE_URL } from "../Config";
import { formatCurrency } from "../utils";
import nl2br from "react-nl2br";
import { CartContext } from "../contexts/CartContext";
import { useTranslation } from 'react-i18next';

import SaleIcon from '../assets/img/sale.webp';

function ProductDetail({ product, sourceScreen }) {
  console.log("Componente ProductDetail.js sendo renderizado!");
  //console.log("Estado inicial - product:", product);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { slug } = useParams();
  let url_social_networks = `${BASE_URL}/product/${slug}`;

  const { addToCart, totalPlacedInCart, setTotalPlacedInCart } = useContext(CartContext);

  console.log("Estado inicial - totalPlacedInCart:", totalPlacedInCart);  

  const hasPrice = product.real_price !== null && product.real_price > 0;
  const hasDiscount = product.discount !== null && product.discount > 0;

  const discountedPrice = hasPrice && hasDiscount
    ? product.real_price - (product.real_price * product.discount / 100)
    : product.real_price;  

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleAddToCart = () => {
    addToCart(product);

    // 🛒 Enviar evento para o GA4 quando um item for adicionado ao carrinho
    window.gtag('event', 'add_to_cart', {
      event_category: 'Carrinho de Compras',
      event_label: product.product_name,
      value: discountedPrice,                 // Preço real com desconto
      original_price: product.real_price,     // Preço cheio
      discount_percentage: product.discount,  // Percentual de desconto aplicado
      event_location: location.pathname,      // rastreia em qual página ocorreu o clique!  
      event_page_type: 'Página Produto',
    });

    //console.log(`Evento enviado para o Google Analytics: ${product.product_name}`);    

    // Verifica se o gtag está disponível antes de chamar
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        event_category: 'Carrinho de Compras',
        event_label: product.product_name,
        value: discountedPrice,
        original_price: product.real_price,
        discount_percentage: product.discount,
        event_location: location.pathname,
        event_page_type: 'Página de descrição do Produto',
      });

      console.log(`✅ Evento enviado para o Google Analytics: ${product.product_name}`);
    } else {
      console.warn("⚠️ Google Analytics não está disponível no momento. Evento não enviado.");
    }    

    const insertQuantityAvailable = (productId, quantityPlacedInCart) => {
      setTotalPlacedInCart((prevTotal) => {
        const currentQuantity = prevTotal[productId] || 0;
        if (currentQuantity + quantityPlacedInCart > 10) {
          return prevTotal;
        }

        const insertedTotal = {
          ...prevTotal,
          [productId]: currentQuantity + quantityPlacedInCart,
        };
        
        console.log("🛒 Novo totalPlacedInCart:", insertedTotal);
        return insertedTotal;
      });
    };

    insertQuantityAvailable(product.id, 1);
  };

  const [isSoldOut, setIsSoldOut] = useState(false);

  let newAvailableInitialQuantity = product.quantity_available - (totalPlacedInCart[product.id] || 0);


  /*
  🧐 RESUMO DO useEffect:
  ----------------------------------------------
  - O `useEffect` executa um código **sempre que suas dependências mudam**.
  - Se usado com um estado que atualiza frequentemente, pode causar **re-renderizações repetidas** do componente.
  - Para evitar re-renderizações desnecessárias, só atualize estados **se realmente houver uma mudança**.
  - ⚠️ Se um `setState` for chamado dentro do `useEffect`, ele pode disparar **uma nova renderização**, criando um loop.
  - ✅ Solução: Verifique se o novo estado é diferente do atual antes de chamá-lo, evitando atualizações inúteis.
  ----------------------------------------------
  */


  useEffect(() => {
    console.log("🔥 useEffect rodando: newAvailableInitialQuantity:", newAvailableInitialQuantity);

    // ✅ Verifica se `isSoldOut` precisa ser atualizado para evitar re-renderizações desnecessárias
    setIsSoldOut((prevIsSoldOut) => {
      const newSoldOutState = newAvailableInitialQuantity <= 0;
      
      // 🔥 Só atualiza `isSoldOut` se houver uma mudança real de estado
      return prevIsSoldOut !== newSoldOutState ? newSoldOutState : prevIsSoldOut;
    });

    console.log("🔄 Novo valor de isSoldOut:", isSoldOut);
  }, [newAvailableInitialQuantity]); // 🔥 O efeito só roda quando `newAvailableInitialQuantity` muda


  console.log("Antes da renderização:");
  console.log("newAvailableInitialQuantity:", newAvailableInitialQuantity);
  console.log("isSoldOut:", isSoldOut);


  return (
    <div>
      {/* Botões de navegação */}
      <div className="navigation-buttons">
        <Link to="/" className="btn btn-light">Home</Link>
        <button onClick={handleGoBack} className="btn btn-light">{t('back')}</button>
      </div>

      {/* Cartão do produto */}
      <Card className="h-100 p-3 hover-card-detail" style={{ position: "relative" }}>
        {/* Ícone de promoção (Sale), apenas se o preço real for maior que o preço unitário */}
        {newAvailableInitialQuantity && hasPrice && hasDiscount && (
          <div className="sale-icon">
            <img src={SaleIcon} alt="Sale LM Brasil" />
          </div>
        )}

        <Card.Body>
          <Card.Title>
            <Button onClick={handleAddToCart} className="primary bt-bag"><SvgBag /></Button>

            {location.pathname !== `/product/${product.slug}` && (
              <>
                <br />
                <Button onClick={() => navigate(`/product/${product.slug}`)} className="primary bt-eye">
                  <SvgEye />
                </Button>
              </>
            )}
          </Card.Title>

          {/* Imagem do produto */}
          <Row>
            <Col sm={12} md={5} lg={5} xl={4} className="my-2 px-xl-5 card-border">
              <Card.Img
                variant="top"
                src={API_BASE_URL + (product.image || "/media/products/no-image.png")}
                className="img-fluid m-auto hover-image p-3"
                alt={product.product_name}
                loading="lazy"
                style={{ width: "300px", height: "300px" }}
              />
            </Col>

            {/* Detalhes do produto */}
            <Col sm={12} md={7} lg={7} xl={8} className="my-2 px-3 px-md-4 pe-md-5 px-xl-5 card-border">
              <h4>{product.product_name}</h4>
              <h5>{product.cod_catalog}</h5>
              <h6>{product.category_product.name}</h6>

              {/* Indicação de produto esgotado */}
              {newAvailableInitialQuantity <= 0 ? <span className="sold-out">{t('sold_out')}</span> : null}

              {/* Exibição de preços */}
              <div className="card-text">
                {newAvailableInitialQuantity > 0 && hasPrice && hasDiscount && (
                  <>
                    <h2 className="red-strike">
                      {formatCurrency(product.real_price)}
                    </h2>
                    <h2>
                      {formatCurrency(discountedPrice)}
                    </h2>
                  </>
                )}

                {newAvailableInitialQuantity > 0 && hasPrice && !hasDiscount && (
                  <h2 className="pb-3">
                    {formatCurrency(product.real_price)}
                  </h2>
                )}
              </div>


              {/* Links para redes sociais */}
              <Card.Text className="social pt-3">
                <a href={`https://api.whatsapp.com/send?text=Olá! Confira este produto incrível: ${url_social_networks}`} target="_blank" rel="noreferrer"><SvgWhatsapp /></a>{" "}
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${url_social_networks}`} target="_blank" rel="noreferrer"><SvgFacebook /></a>{" "}
                <a href={`https://twitter.com/intent/tweet?url=${url_social_networks}&text=Confira este produto incrível:`} target="_blank" rel="noreferrer"><SvgTwitter /></a>{" "}
              </Card.Text>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Informações adicionais do produto */}
      {product.info && (
        <p className="text-start py-5">{nl2br(product.info)}</p>
      )}
    </div>

  );
}

export default ProductDetail;
